export const checkCookie = () => {
  let cookieEnabled = navigator.cookieEnabled
  if (!cookieEnabled) {
    document.cookie = 'testcookie'
    // eslint-disable-next-line eqeqeq
    cookieEnabled = document.cookie.indexOf('testcookie') != -1
  }
  return cookieEnabled
}
